import React, { useEffect } from "react"
import { Container } from "./styles/page"
export default function Page(props) {
  useEffect(() => {
    document.title = `${props.title} | TheMovieBase`
    document.head.children.namedItem("description").content = props.disc ? props.disc : "Movie & Tv Shows Reviews"
    window.scrollTo(0, 0)
    // eslint-disable-next-line
  }, [props.title, props.disc])
  return <Container>{props.children}</Container>
}
